/**
 * SuspenseBoundary
 * Reusable Suspense wrapper with a Spinner fallback for lazy-loaded pages and components.
 */

import { Suspense } from 'react';
import type { ReactNode } from 'react';
import { Spinner } from '../components';

interface SuspenseBoundaryProps {
  children: ReactNode;
  fallback?: ReactNode;
}

export function SuspenseBoundary({ children, fallback }: SuspenseBoundaryProps) {
  return (
    <Suspense
      fallback={
        fallback ?? (
          <div className="min-h-[200px] flex items-center justify-center">
            <Spinner size="lg" label="Loading..." />
          </div>
        )
      }
    >
      {children}
    </Suspense>
  );
}

export default SuspenseBoundary;
